import React, {Component} from 'react';
import {compose} from "redux";
import {withFirestore, firestoreConnect, isLoaded, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";
import {SUBSCRIBED} from "../../utils/subsciptionStatus";
import {CALL_DB_PATH, COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {withRouter, Redirect} from "react-router-dom";
import {DETAILED_CALL_URL} from "../../constants/URLS";


const withSubscriptionValidatorHoc = (OriginalComponent) => {
    class WithSubscriptionValidatorHoc extends Component {
        render() {
            /*console.log('hoc')
            console.log(this.props)
            console.log('---')*/
            /*console.log(isLoaded(this.props.company) && !isEmpty(this.props.company) &&
                isLoaded(this.props.profile) && ! isEmpty(this.props.profile))*/
            if (isLoaded(this.props.profile) && ! isEmpty(this.props.profile) &&
                isLoaded(this.props.company) && !isEmpty(this.props.company)
            ){
                let company = this.props.company[0]
                if(company.subscriptionStatus === SUBSCRIBED){
                    //console.log('compony sub')
                    if(this.props.profile.role === 'employee'){
                        //console.log('employee')
                        if(company.employees && company.employees.includes(this.props.auth.uid)){
                            //console.log('includes')
                            return <OriginalComponent {...this.props}/>
                        }
                    }
                    if(this.props.profile.role === 'company'){
                        //console.log('comp')
                        return <OriginalComponent {...this.props}/>
                    }
                }
                /*if(this.props.match.path === DETAILED_CALL_URL+':id'){
                    if(!isEmpty(this.props.call)){
                        if(this.props.call.takenBy === this.props.auth.uid){
                            return <OriginalComponent {...this.props}/>
                        }
                    }
                }*/

                return <Redirect to={'/calls/subscribe'}/>

            } else {
                return <div>Loading...</div>
            }



        }
    }


    return compose(
        withRouter,
        connect(state => ({
            company: state.firestore.ordered[COMPANY_DB_PATH],
            //call: state.firestore.data.call,
        })),
        firestoreConnect(state => {
            //console.log(state)
            if(state.profile && !state.profile.isEmpty){
                return [
                    {
                    collection: COMPANY_DB_PATH,
                    doc: state.profile.companyId
                    },
                    /*{
                        collection: CALL_DB_PATH,
                        doc: state.match.params.id,
                        storeAs: 'call',
                    }*/
                ]
            } else {
                return []
            }

        }),
    )(WithSubscriptionValidatorHoc)
}

export default withSubscriptionValidatorHoc;